module.exports = __webpack_public_path__ + "img/banner.3e2365c1.png";